import { RedAsteriskWrapper } from './styled';

export const RedAsterisk: React.FC = () => (
  <RedAsteriskWrapper>*</RedAsteriskWrapper>
);
